import { Group } from './group.model';
import { GroupInterface } from './group.interface';

export class GroupFactory {

    static empty(): Group {
        return new Group('', '', '', [], [], [], [], false, false, 0, [], '', [], [], '');
    }

    static fromObject(raw: GroupInterface | any): Group {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Group(
            raw.id,
            raw.name,
            raw.name02,
            raw.teachers || [],
            raw.teachers02 || [],
            raw.groups || [],
            raw.deactivatedRoles || [],
            raw.invisibleToMobile,
            raw.isGroup,
            raw.userTotalCount,
            raw.roles || [],
            raw.building,
            raw.buildings,
            raw.units,
            raw.description,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/groups/shared/group.factory.ts